import { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import FirstComponet from "../team/FirstComponet";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      onClick={() => setSelected(title)}
      icon={icon}
      style={{
        margin: "6px 12px",
        borderRadius: "10px",
        color: colors.grey[100],
      }}
    >
      <Typography fontSize="14px" fontWeight={500}>
        {title}
      </Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  return (
    <Box
      sx={{
        height: "100vh",
        "& .pro-sidebar-inner": {
          background: "linear-gradient(180deg, #0f172a, #020617) !important",
        },
        "& .pro-menu-item": {
          transition: "all 0.3s ease",
        },
        "& .pro-menu-item:hover": {
          backgroundColor: "rgba(99,102,241,0.12) !important",
          borderRadius: "10px",
        },
        "& .pro-menu-item.active": {
          backgroundColor: "rgba(99,102,241,0.25) !important",
          borderLeft: "4px solid #6366f1",
        },
        "& .pro-inner-item": {
          padding: "10px 20px !important",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="circle">
          {/* LOGO */}
          <MenuItem
            icon={<MenuOutlinedIcon />}
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={{
              marginBottom: "20px",
              color: "#fff",
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml={1}
              >
                <Typography variant="h4" fontWeight="bold">
                  MEDESHINE
                </Typography>
                {/* <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon sx={{ color: "#fff" }} />
                </IconButton> */}
              </Box>
            )}
          </MenuItem>

          {/* PROFILE */}
          {/* PROFILE */}
          {!isCollapsed && (
            <Box
              mb={3}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <Box
                sx={{
                  width: 96,
                  height: 96,
                  borderRadius: "50%",
                  border: "3px solid #6366f1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                }}
              >
                <img
                  src="../../assets/user.png"
                  alt="user"
                  style={{
                    width: "88px",
                    height: "88px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              </Box>

              <Typography
                variant="h6"
                fontWeight="bold"
                color="#fff"
                sx={{ lineHeight: 1.2 }}
              >
                Admin
              </Typography>

              <Typography fontSize="12px" color="#a5b4fc">
                Administrator
              </Typography>
            </Box>
          )}

          {/* MENU */}
          <Box>
            <Item
              title="Dashboard"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Typography
              fontSize="12px"
              color="#94a3b8"
              sx={{ ml: 3, mt: 2, mb: 1 }}
            >
              MANAGEMENT
            </Typography>

            <Item
              title="Category"
              to="/team"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Subcategory"
              to="/contacts"
              icon={<ContactsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Products"
              to="/invoices"
              icon={<ReceiptOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Orders"
              to="/order"
              icon={<ReceiptOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="First slider"
              to="/firstslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Secound slider"
              to="/secoundslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
             <Item
              title="Health slider"
              to="/healthslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
             <Item
              title="Exclusive slider"
              to="/exclusiveslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Shopbycategory slider"
              to="/shopbycategoryslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Arrivals slider"
              to="/arrivalslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
              <Item
              title="ExclusiveStore slider"
              to="/exclusivestoreslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Insurance slider"
              to="/insuranceslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Personal slider"
              to="/personalslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
             <Item
              title="Topbrand slider"
              to="/personalslider"
              icon={<ReceiptOutlinedIcon/>}
              selected={selected}
              setSelected={setSelected}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
